import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { OrderFields } from 'types/order'

import { selectOrderRead } from 'store/order/order.selectors'

import TextWithPrefix from 'components/atoms/TextWithPrefix'
import BoldText from 'components/atoms/BoldText'
import { Icon, IconType } from 'components/atoms/Icon'

import classes from '../Driver/style.module.css'

const Manager: React.FC = () => {
  const form = useSelector(selectOrderRead)

  return (
    <>
      <ul className="list-group row needs-validation">
        <li className="list-group-item">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <span
            onClick={() => {
              window.scrollTo(0, 0)
            }}
            className={classNames(classes.anchor)}
          >
            <Icon type={IconType.Box} width="24px" height="24px" />
          </span>
          <div className={classes.title}>Рейс</div>
          <div className="d-flex flex-column" style={{ gap: '2px' }}>
            <TextWithPrefix prefix="Дата начала:" text={<BoldText text={form[OrderFields.ROUTE_DATE_START]} />} />

            <TextWithPrefix prefix="Грузоотправитель/Заказчик:" text={<BoldText text={form[OrderFields.SHIPPER]} />} />

            <TextWithPrefix prefix="Маршрут:" text={<BoldText text={form[OrderFields.ROUTE_TRIP]} />} />

            <TextWithPrefix prefix="Груз:" text={<BoldText text={form[OrderFields.CARGO]} />} />
          </div>
        </li>
      </ul>
    </>
  )
}

export default Manager
